import { b2bThriftPlan } from '../api/b2bThriftPlan';

export const downloadCsvTemplateByName = async (templateName: string): Promise<void> => {
  const response = await b2bThriftPlan.fetchCsvTemplates({
    limit: 1,
    offset: 0,
    filterBy: 'name',
    filterValue: templateName,
    filterKey: 'name',
  });

  const template = response.data?.templates?.[0];

  if (!template?.url) {
    throw new Error('CSV template not found.');
  }

  const link = document.createElement('a');
  link.href = template.url;
  link.download = `${template.name}.csv`;
  link.target = '_blank';
  link.rel = 'noopener noreferrer';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
